<template>
  <div
    class="app font-degular font-normal"
    style="-webkit-tap-highlight-color: transparent"
  >
    <div v-show="!mainMenuVisible" class="screen">
      <!-- v-if="isDataLoaded"> -->
      <vue-drawer-layout
        v-show="isDataLoaded"
        ref="drawer"
        :drawer-width="240"
        :z-index="0"
        :drawable-distance="Math.floor(240 / 3)"
        :animatable="true"
        :backdrop="true"
        :backdrop-opacity-range="[0, 0.4]"
        :enable="!dragLock"
        :content-drawable="true"
        @mask-click="toggleDrawer"
      >
        <side-nav
          slot="drawer"
          class="drawer-content"
          @toggleDrawer="toggleDrawer"
        />
        <div slot="content" class="router-view select-none relative">
          <!-- <div> -->
          <!-- <side-nav /> -->
          <router-view />
          <!-- <div class="h-32 w-full z-0"></div> -->
          <!-- <div
            class="h-16 w-full sticky bottom-0 z-50"
            :class="route == 'tasks' ? 'bg--gradient-up' : ''"
          ></div> -->
          <!-- </div> -->
        </div>
      </vue-drawer-layout>
      <!-- <div v-else class="router-view">
        <router-view />
      </div> -->
    </div>

    <!-- <div v-if="!isDataLoaded" class="router-view">
      <router-view />
    </div> -->

    <transition name="nice-modal-fade">
      <button
        id="FAB"
        v-show="isDataLoaded && fabVisible"
        class="mr-auto bottom-0 mb-10 p-1 sm:p-2 w-16 h-16 sm:w-20 sm:h-20 rounded-full select-none font-semibold cursor-pointer bg-transparent fixed z-30"
        style="left: 50%; transform: translateX(-50%)"
        @click.stop="toggleDrawer"
      >
        <img
          src="@/assets/svg/SLS-Icon-Fire.svg"
          class="w-full h-full opacity-75 hover:opacity-100 transition-opacity duration-100"
        />
      </button>
    </transition>

    <!-- <main-menu
      v-if="mainMenuVisible"
      @click.native="toggleMainMenu"
      :visible="mainMenuVisible"
    /> -->
    <modal-login />
    <modal-logout />
    <modal-loading />
    <modal-edit-recipe />
    <install-prompt />
    <modal-generate-report />
    <modal-select-store @confirm="switchStore" />
    <modal-product-transfer />
    <modal-message />
    <modal-confirm />
  </div>
</template>

<script>
// import MainMenu from '@/components/MainMenu'
import InstallPrompt from '@/components/InstallPrompt'
import SideNav from '@/components/SideNav'
import ModalLogin from '@/components/ModalLogin.vue'
import ModalLogout from '@/components/ModalLogout.vue'
import ModalEditRecipe from '@/components/ModalEditRecipe'
import ModalMessage from '@/components/ModalMessage'
import ModalLoading from '@/components/ModalLoading'
import ModalGenerateReport from '@/components/ModalGenerateReport'
import ModalProductTransfer from '@/components/ModalProductTransfer'
import ModalSelectStore from '@/components/ModalSelectStore'
import ModalConfirm from '@/components/ModalConfirm'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    InstallPrompt,
    SideNav,
    ModalLogin,
    ModalEditRecipe,
    ModalLogout,
    ModalLoading,
    ModalGenerateReport,
    ModalSelectStore,
    ModalProductTransfer,
    ModalMessage,
    ModalConfirm
    // MainMenu
  },
  computed: {
    ...mapState('config', [
      'dragLock',
      'loading',
      'isDataLoaded',
      'mainMenuVisible',
      'fabVisible'
    ]),
    route() {
      return this.$route.name
    }
  },
  watch: {
    loading() {
      this.loading
        ? this.$modal.show('modal--loading')
        : this.$modal.hide('modal--loading')
    }
  },
  methods: {
    ...mapActions('config', ['toggleMainMenu']),
    toggleDrawer() {
      this.$refs.drawer.toggle()
    },
    switchStore() {
      console.log('switching')
    }
  },
  created() {
    // start the time module clock!
    this.$store.dispatch('time/updateTime')

    // THIS WAS AN ATTEMPT TO FIX THE IOS CHROME HEIGHT ISSUE - NOW IN CSS .app and .html/.body
    // function setDocHeight() {
    //   document.documentElement.style.setProperty(
    //     '--vh',
    //     `${window.innerHeight / 100}px`
    //   )
    //   alert(window.innerHeight)
    // }

    // window.addEventListener('resize', setDocHeight)
    // window.addEventListener('orientationchange', setDocHeight)
    // setDocHeight()
  }
}
</script>
